import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { useThunk } from "../../hooks/useThunk";
import { sendSupportRequest } from "../../store";
import { fetchUserProperties } from "../../store";
import FormWrapper from "../../components/Common/FormWrapper";
import showToast from "../../utils/toastNotifications";
import { supportRequestTypes } from "../../constants/commonConstants";

const MAX_LABEL_CHARS = 24;

const LegalSupport = () => {
  const [selectedTenant, setSelectedTenant] = useState("");
  const [description, setDescription] = useState("");
  const [touched, setTouched] = useState({ tenant: false, description: false });
  const [doSendRequest, isLoading, error] = useThunk(sendSupportRequest);
  const [doFetchUserProperties, isFetchUserProperties, fetchUserPropertiesError] = useThunk(fetchUserProperties);
  
  const isValid = () => {
    // const tenantValid = !!selectedTenant;
    const descLength = description.trim().length;
    const descValid = descLength >= 10 && descLength <= 500;

    setTouched({ tenant: true, description: true });

    if (!descValid) {
      showToast("error", "Please fill all required fields correctly.");
      return false;
    }

    return true;
  };

  const properties = useSelector((state) => state.property.properties);
  
    const loadUserProperties = async () => {
      const result = await doFetchUserProperties();
      if (result?.success) {
        // console.log("Properties fetched successfully:");
      } else {
        console.error("Error fetching properties:", result?.error?.message);
      }
    }
  
    useEffect(() => {
      if (!properties.length > 0) {
        loadUserProperties();
      }
    }, []);
  
    const tenants = useMemo(() => {
      if (!Array.isArray(properties)) return [];
      return properties
        .flatMap(property =>
          (property.units || [])
            .filter(unit => unit.tenant)
            .map(unit => {
            const fullLabel = `${unit.tenant.name} (Unit ${unit.unitName})`;
            const isLong = fullLabel.length > MAX_LABEL_CHARS;
            const label = isLong
              ? fullLabel.slice(0, MAX_LABEL_CHARS - 1) + "…"
              : fullLabel;
            return {
              value: unit._id,
              tenantId: unit.tenant._id,
              label,     
              fullLabel,   
              isLong,
            };
          })
        );
    }, [properties]);

  const handleLegalSubmit = async () => {
    if (isValid()) {

      const data = {
        unitId: selectedTenant?.value || "",
        tenantId: selectedTenant?.tenantId || "",
        legalDescription: description.trim(),
        requestType: supportRequestTypes.LEGAL,
      }

      const result = await doSendRequest(data);

      if (result?.success) {
        showToast("success", "Legal issue submitted successfully.");
      } else {
        showToast("error", result?.error?.message);
      }
    }
  };

  return (
    <div className="p-4 sm:p-6 md:p-[30px]">
      <div className="flex justify-center">
        <div className="w-full ">
          <FormWrapper
            wrapperHeight="h-[604px] sm:h-[620px] md:h-[630px] lg::h-[638px]"
            // dropdown 
            dropdownLabel="Contact Legal Support"
            dropdownPlaceholder="Select Tenant"
            dropdownOptions={tenants}
            dropdownValue={selectedTenant}
            dropdownRequired={false}
            onDropdownChange={(selected) => {
              setSelectedTenant(selected);
              // setTouched((prev) => ({ ...prev, tenant: true }));
            }}
            // dropdownError={touched.tenant && !selectedTenant ? "Please select a tenant" : ""}
            dropdownFormatOptionLabel={(option) => (
              <span
                title={option.isLong ? option.fullLabel : undefined}
                className="block max-w-[28ch] overflow-hidden text-ellipsis whitespace-nowrap"
              >
                {option.label}
              </span>
            )}
            dropdownSingleValueRenderer={({ data }) => (
              <span
                title={data?.isLong ? data.fullLabel : undefined}
                className="block max-w-[28ch] overflow-hidden text-ellipsis whitespace-nowrap"
              >
                {data?.label}
              </span>
            )}
            // textarea
            textareaLabel="Reason / Description"
            textareaPlaceholder="Describe the legal issue..."
            textareaValue={description}
            textareaRequired={true}
            onTextareaChange={(e) => {
              setDescription(e.target.value);
              setTouched((prev) => ({ ...prev, description: true }));
            }}
            textareaError={
              touched.description && !description.trim()
                ? "This field is required."
                : touched.description && (description.trim().length < 10 || description.trim().length > 500)
                ? "Description must be between 10 and 500 characters."
                : ""
            }

            // button
            buttonLabel="Submit"
            onSubmit={handleLegalSubmit}
            loading={isLoading}
            disabled={isLoading || !description.trim()}
            required
          />
        </div>
      </div>
    </div>
  );
};

export default LegalSupport
